import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Tooltip from '../../Tooltip';

const ThCell = ({
  sortable,
  text,
  sortOrder,
  tooltipText,
  sortBy,
  onSort,
  columnSortOrder,
  className,
  colSpan,
  style,
  isTooltipFirst,
  element,
  isTableLayout,
  entireCellTooltip,
}) => {
  let tooltip = '';
  if (tooltipText && !entireCellTooltip) {
    tooltip = (
      <Tooltip content={tooltipText}>
        <i
          className={cx('hicon-question-circle', {
            'mr-xxxs': isTooltipFirst,
            'ml-xxxs': !isTooltipFirst,
            'hicon-question-circle': !isTableLayout,
          })}
        />
      </Tooltip>
    );
  }

  const handleSort = () => {
    if (sortable) {
      let sortDirection;
      const useColumnSortOrder = !sortOrder && columnSortOrder;

      if (useColumnSortOrder) sortDirection = columnSortOrder;
      else sortDirection = sortOrder === 'desc' ? 'asc' : 'desc';

      onSort(sortBy, sortDirection);
    }
  };

  const thClassName = (specificClassName) =>
    cx(
      {
        sortable,
        'active-up': sortOrder === 'asc',
        'active-down': sortOrder === 'desc',
        [`inactive-${columnSortOrder}`]: !!columnSortOrder,
      },
      className,
      specificClassName
    );

  const renderCellContent = () => (
    <span className={cx({ 'sortable-carets': sortable })}>
      {isTooltipFirst && tooltip}
      {element}
      {text}
      {!isTooltipFirst && tooltip}
    </span>
  );

  const cellContent = isTableLayout ? (
    <th className={thClassName()} colSpan={colSpan} style={style} onClick={handleSort}>
      {renderCellContent()}
    </th>
  ) : (
    <div className={thClassName('d-th d-table-cell')} style={style} onClick={handleSort}>
      {renderCellContent()}
    </div>
  );

  return (
    <Tooltip content={entireCellTooltip && tooltipText ? tooltipText : null}>{cellContent}</Tooltip>
  );
};

ThCell.propTypes = {
  sortable: PropTypes.bool,
  columnSortOrder: PropTypes.string,
  sortOrder: PropTypes.string,
  sortBy: PropTypes.string,
  text: PropTypes.string,
  tooltipText: PropTypes.string,
  onSort: PropTypes.func,
  style: PropTypes.object,
  colSpan: PropTypes.number,
  className: PropTypes.string,
  isTooltipFirst: PropTypes.bool,
  isTableLayout: PropTypes.bool,
  element: PropTypes.element,
  entireCellTooltip: PropTypes.bool,
};

ThCell.defaultProps = {
  sortable: false,
  sortOrder: '',
  sortBy: '',
  style: {},
  className: '',
};

export default ThCell;
